'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (
        !desc ||
        ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)
      ) {
        desc = {
          enumerable: true,
          get: function () {
            return m[k];
          },
        };
      }
      Object.defineProperty(o, k2, desc);
    }
    : function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
    });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
      Object.defineProperty(o, 'default', { enumerable: true, value: v });
    }
    : function (o, v) {
      o['default'] = v;
    });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.convertLocalToUTCDate = exports.convertUTCToLocalDate = void 0;
const react_1 = __importStar(require('react'));
const rc_utils_1 = require('@hangar31/rc-utils');
const react_datepicker_1 = __importDefault(require('react-datepicker'));
const form_1 = require('../../contexts/form');
const _helpers_1 = require('./_helpers');
function convertUTCToLocalDate(date) {
  let d = new Date(date);
  d = new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes()
  );
  return d;
}
exports.convertUTCToLocalDate = convertUTCToLocalDate;
function convertLocalToUTCDate(date) {
  let d = new Date(date);
  d = new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes()
    )
  );
  return d;
}
exports.convertLocalToUTCDate = convertLocalToUTCDate;
function DateInput(_a) {
  var { name, transform } = _a,
    props = __rest(_a, ['name', 'transform']);
  const { fields, setField } = (0, form_1.useForm)();
  const value = (0, rc_utils_1.getByPath)(fields, name);
  (0, react_1.useEffect)(() => {
    if (!value) {
      setField(
        name,
        convertLocalToUTCDate(new Date().toISOString()).toISOString()
      );
    }
  }, [value]);
  return react_1.default.createElement(
    react_1.default.Fragment,
    null,
    react_1.default.createElement(
      react_datepicker_1.default,
      Object.assign(
        {
          selected: convertUTCToLocalDate(value || new Date().toISOString()),
          onBlur: _helpers_1.checkValidity,
          onChange: date => {
            if (date && !(date instanceof Array)) {
              if (transform)
                transform(date);
              setField(name, convertLocalToUTCDate(date.toISOString()).toISOString());
            }
          },
          peekNextMonth: true,
          placeholderText: "mm/dd/yyyy",
          showMonthDropdown: true,
          dropdownMode: "select",
          showYearDropdown: true
        },
        props
      )
    )
  );
}
exports.default = DateInput;
//# sourceMappingURL=DateInput.js.map
